import type {ReactNode} from 'react';
import {Table} from '@mantine/core';

/**
 * Diff-aware table cell — colors/bolds its contents red or green depending on
 * which side of a two-way comparison it represents and whether the values differ.
 * @registry Table cell for two-column diff views (original/current), red/green highlight.
 *
 * Ported from `library-m/data-display/DiffCell`. Prop surface kept identical.
 */
export interface DiffCellProps {
  /** Which side of the diff this cell shows. Drives the highlight color when isDifferent. */
  side: 'original' | 'current';
  /** Whether the original and current values differ. Drives red/green + bold. */
  isDifferent: boolean;
  colSpan?: number;
  children?: ReactNode;
}

export const DiffCell = ({
  side,
  isDifferent,
  colSpan,
  children,
}: DiffCellProps) => {
  const color = isDifferent
    ? side === 'original'
      ? 'red'
      : 'green'
    : 'dimmed';

  return (
    <Table.Td
      c={color}
      colSpan={colSpan}
      style={{fontWeight: isDifferent ? 700 : 400, verticalAlign: 'top'}}>
      {children}
    </Table.Td>
  );
};
